/**
 * Rentang tanggal default untuk halaman laporan ERP.
 *
 * Satu tempat untuk seluruh laporan supaya "seminggu terakhir" berarti sama di
 * mana pun. Sebelumnya setiap halaman dibuka dengan tanggal KOSONG, yang oleh
 * backend diartikan "tanpa batas tanggal" — jadi sekali dibuka, laporan memindai
 * seluruh riwayat toko. Selain lambat, angkanya juga menyesatkan: "Total
 * Penjualan" tanpa rentang berarti sepanjang masa, bukan periode kerja.
 *
 * Padanannya di POS ada di `pos-frontend/src/features/reports/dateRange.ts`
 * (`defaultReportRange`) — keduanya HARUS memakai jumlah hari yang sama, kalau
 * tidak laporan yang sama di dua aplikasi akan menampilkan angka berbeda.
 */

/** Lebar rentang default: 7 hari TERMASUK hari ini. */
export const DEFAULT_RANGE_DAYS = 7;

/**
 * Tanggal lokal sebagai `YYYY-MM-DD`.
 *
 * TIDAK memakai `toISOString()` langsung: fungsi itu mengubah ke UTC lebih dulu,
 * sehingga sebelum jam 07:00 WIB tanggalnya mundur satu hari dan laporan dibuka
 * dengan rentang yang bergeser.
 */
export function toLocalISODate(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

/** Tanggal awal default — hari ini dikurangi (DEFAULT_RANGE_DAYS - 1). */
export function defaultReportStart() {
  const start = new Date();
  start.setDate(start.getDate() - (DEFAULT_RANGE_DAYS - 1));
  return toLocalISODate(start);
}

/** Tanggal akhir default — hari ini. */
export function defaultReportEnd() {
  return toLocalISODate(new Date());
}

/** Untuk halaman yang menyimpan filternya sebagai satu objek query. */
export function defaultReportDates() {
  return { start_date: defaultReportStart(), end_date: defaultReportEnd() };
}
